import { getNMRHints } from "./getNMRHints.js";
/**
 *
 * @param correct
 * @param proposed
 * @param providedHints
 */
export function getNextNMRHint(correct, proposed, providedHints) {
    const hints = getNMRHints(correct, proposed);
    const possibleHints = hints.filter((possibleHint) => !providedHints.some((providedHint) => possibleHint.hash === providedHint.hash));
    if (possibleHints.length === 0)
        return undefined;
    return {
        ...possibleHints[0],
        idCode: proposed.getIDCode(),
    };
}
//# sourceMappingURL=getNextNMRHint.js.map